var _line, _line2, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaneChanging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 20,
    x2: 30,
    y2: 80,
    stroke: "black",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 20,
    x2: 70,
    y2: 80,
    stroke: "black",
    strokeWidth: 5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "40,40 30,20 20,40",
    fill: "black"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "80,40 70,20 60,40",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaneChanging);
export default __webpack_public_path__ + "static/media/lane-changing.f7e5a96dfcf974b629c467970736ab7a.svg";
export { ForwardRef as ReactComponent };